import React, { useState, useEffect } from "react";
import { Form, Input, DatePicker, Button, Select, theme, Space, Breadcrumb, Spin, Layout, Row, Col } from "antd";
import axios from "axios";
import moment from "moment";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { MAINAPIURL,APPBACKGROUND_COLOR } from '../appsettings.js';
import Headerdiv from "../layout/header.js";
import Footerdiv from "../layout/footer.js";
import { Link, useNavigate } from "react-router-dom";
import { AlertError, AlertSuccess } from '../usableclasses.js';

const { Content } = Layout;
const { Option } = Select;

const modules = {
    toolbar: [
        [{ header: [1, 2, false] }],
        ["bold", "italic", "underline", "strike"],
        [{ list: "ordered" }, { list: "bullet" }],
        ["link"],
        [{ align: [] }],
        [{ color: [] }, { background: [] }],
        ["clean"],
    ],
};
const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "list",
    "bullet",
    "link",
    "align",
    "color",
    "background",
];

const PurchaseOrderCreate = ({ currentUser }) => {

    const ApiURL = MAINAPIURL;
    const TOKEN = localStorage.getItem("AUTHCODE");
    const UPDATED_BY = localStorage.getItem("USERID");
    const { token: { colorBgContainer, borderRadiusLG }, } = theme.useToken();
    const [vendors, setVendors] = useState([]);
    const [poNote, setPoNote] = useState("");
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    useEffect(() => {
        fetchVendors();
    }, []);

    const fetchVendors = async () => {
        try {
            const response = await axios.get(`${ApiURL}/vendor/dropdown`, {
                headers: { SystemAccessToken: TOKEN },
            });
            setVendors(response.data);
        } catch (error) {
            AlertError("Failed to load vendors");
        }
    };

    const onFinish = async (values) => {
        const requestData = {
            vendorId: values.vendorId,
            vendorBillNo: values.vendorBillNo,
            vendorBillDate: values.vendorBillDate.format("YYYY-MM-DD"),
            poNote: poNote,
            createdBy: UPDATED_BY,
        };

        try {
            const response = await axios.post(`${ApiURL}/purchase/create`, requestData, {
                headers: { SystemAccessToken: TOKEN },
            });
            if (response.status === 200) {
                
                AlertSuccess("Purchase order created successfully");
                navigate(`/poedit/${response.data}`);
             
            }
        } catch (error) {
            AlertError("Failed to create purchase order");
        }
    };

    return (
        <Spin spinning={loading} tip="Processing...">
            <Layout style={{ backgroundColor: APPBACKGROUND_COLOR }}>
                <Headerdiv />
                <Content style={{ padding: '10px', }} >
                    <Breadcrumb style={{ margin: "16px 0" }}>
                        <Breadcrumb.Item><Link to="/polist">Purchase Orders</Link></Breadcrumb.Item>
                        <Breadcrumb.Item>Create Purchase Order</Breadcrumb.Item>
                    </Breadcrumb>
                    <div style={{ padding: 10, minHeight: '65vh', background: colorBgContainer, borderRadius: borderRadiusLG, }} >
                        <Space
                            direction="vertical"
                            style={{ width: "100%", padding: "15px" }}
                        >
                            <h2>Create a Purchase Order</h2>
                            <Form form={form} layout="vertical" onFinish={onFinish}>
                                <Row>
                                    <Col xs={24} md={8} style={{ padding: '5px' }}>
                                        <Form.Item
                                            label="Vendor"
                                            name="vendorId"
                                            rules={[{ required: true, message: "Vendor is required" }]}
                                        >
                                            <Select placeholder="Select a vendor">
                                                {vendors.map((vendor) => (
                                                    <Option key={vendor.id} value={vendor.id}>{vendor.label}</Option>
                                                ))}
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={8} style={{ padding: '5px' }}>
                                        <Form.Item
                                            label="Vendor Bill No"
                                            name="vendorBillNo"
                                            rules={[
                                                { required: true, message: "Vendor Bill No is required" },
                                                { max: 30, message: "Maximum 30 characters allowed" },
                                            ]}
                                        >
                                            <Input placeholder="Enter Vendor Bill No" />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={8} style={{ padding: '5px' }}>
                                        <Form.Item
                                            label="Vendor Bill Date"
                                            name="vendorBillDate"
                                            rules={[{ required: true, message: "Vendor Bill Date is required" }]}
                                        >
                                            <DatePicker
                                                disabledDate={(current) => current && current > moment().endOf("day")}
                                                style={{ width: "100%" }}
                                            />
                                        </Form.Item>

                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={24} md={24} style={{ padding: '5px' }}>
                                        <Form.Item label="Purchase Order  Note" name="poNote">
                                            <ReactQuill
                                                value={poNote}
                                                onChange={setPoNote}
                                                modules={modules}
                                                formats={formats}
                                                theme="snow"
                                                placeholder="Enter your description..."
                                            />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={24} style={{ padding: '5px',display:'flex',justifyContent:'flex-end',alignItems:'flex-end' }}>
                                        <Form.Item>
                                            <Button type="primary" htmlType="submit">Create Purchase Order</Button>
                                        </Form.Item>
                                    </Col>
                                </Row>

                            </Form>

                        </Space>
                    </div>
                </Content>
                <Footerdiv />

            </Layout>
        </Spin>
    );
};

export default PurchaseOrderCreate;
